import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import { useLang } from "../../utils/LangContext";

import localStorageHelper from "../../utils/localStorageHelper";
import { fetchData } from "../../utils/apiUtils";

function PublicGameChoice() {
  const { t } = useLang();
  const { hash } = useParams();

  // initialize from localStorage if present
  const [game, setGame] = useState(() => localStorageHelper.getItem("game"));

  useEffect(() => {
    if (!hash) return; // no param → skip

    const loadGameInfo = async () => {
      try {
        const data = await fetchData(
          "/api/v1/game/info?game_hash=" + encodeURIComponent(hash)
        );
        if (data) {
          setGame(data);
          localStorageHelper.setItem("game", data);
        }
      } catch (err) {
        console.error("Failed to load game info:", err);
      }
    };

    loadGameInfo();
  }, [hash]);

  // While loading (or if there's no game yet)
  if (!game) {
    return (
      <Layout>
        <div className="text-center">
          <h1 className="fw-bold">{t("Loading game…")}</h1>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="text-center">
        <h1 className="fw-bold">
          {t("Start Game")}: {game.name}
        </h1>
        <div className="mt-4">
          <Link to="/public/create-team" className="btn btn-primary m-2">
            {t("Create New Team")}
          </Link>
          <Link to="/public/join-team" className="btn btn-secondary m-2">
            {t("Join Team")}
          </Link>
        </div>
      </div>
    </Layout>
  );
}

export default PublicGameChoice;
